









































































import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '@/models/commonVue';
import Modal from './Modal.vue';
import DropDownEntity from './DropDownEntity.vue';
import Dimmer from './Dimmer.vue';
import ApiList from '@/api/list';
import Module from '@/api/module';
import Lesson from '@/api/lesson';
import Exercise from '@/api/exercise';
import { BusEvent } from '@/models/bus';
import Submodule from '@/api/submodule';
import { copyExercise } from '@/util/copy-content/copy-exercise';
import { isNil } from 'lodash';

@Component({
  components: {
    modal: Modal,
    'drop-down-entity': DropDownEntity,
    dimmer: Dimmer
  }
})
export default class CopyExercise extends CommonVue {
  @Prop({ type: Exercise }) public exercise!: Exercise;
  public showModal: boolean = false;

  public moduleList: ApiList<Module> = null;
  @Model() public moduleId!: number;

  public submodules: ApiList<Submodule> = null;
  @Model() public subModuleId!: number;

  public lessonList: ApiList<Lesson> = null;
  @Model() public lessonId!: number;

  public async beforeMount() {
    await this.load();
  }

  private async load() {
    this.moduleList = await Module.listAll();
  }

  @Watch('moduleId')
  public async loadSubModules(value: number, oldValue: number) {
    try {
      this.submodules = await Submodule.getSubmodulesOfModule(this.moduleId);
    } catch (e) {
      this.error = true;
      this.$bus.$emit(BusEvent.ERROR, 'Could not get submodule information', e);
    }
  }

  @Watch('subModuleId')
  public async loadLessons(value: number, oldValue: number) {
    try {
      this.lessonList = await Lesson.getLessonsOfSubModule(this.subModuleId);
    } catch (e) {
      this.error = true;
      this.$bus.$emit(BusEvent.ERROR, 'Could get lesson information', e);
    }
  }

  public async show() {
    this.showModal = true;
  }

  public async close() {
    this.showModal = false;
    this.moduleList = null;
    this.submodules = null;
    this.lessonList = null;
  }

  public async copyClicked() {
    const confirm = this.askConfirmation();
    if (
      confirm &&
      !isNil(this.moduleId) &&
      !isNil(this.subModuleId) &&
      !isNil(this.lessonId)
    ) {
      this.busy = true;
      try {
        const result = await copyExercise(this.exercise, this.lessonId);
        this.busy = false;
        console.log('RESULT', result);
        this.close();
      } catch (error) {
        this.busy = false;
        console.log('error', error.message);
        this.$bus.$emit(BusEvent.ERROR, 'Could not copy excersise', error);
      }
    }
  }

  private askConfirmation() {
    let answer = false;
    if (this.lessonList || !(this.lessonId === undefined)) {
      answer = window.confirm(
        'Do you really want to copy content to this lesson?'
      );
    } else {
      answer = window.confirm(
        'You need to choose module, sub-module and lesson to copy!'
      );
    }
    return answer;
  }
}
